import { useCallback, useEffect, useState } from "react";
import { habitacionesApi } from "../api/habitacionesApi";

export function useHabitaciones() {
    const [habitaciones, setHabitaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const reload = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const data = await habitacionesApi.list();
            setHabitaciones(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e?.message || "Error cargando habitaciones");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    const createHabitacion = useCallback(async (payload) => {
        await habitacionesApi.create(payload);
        await reload();
    }, [reload]);

    const updateHabitacion = useCallback(async (payload) => {
        await habitacionesApi.update(payload);
        await reload();
    }, [reload]);

    const deleteHabitacion = useCallback(async (id) => {
        await habitacionesApi.remove(id);
        await reload();
    }, [reload]);

    return {
        habitaciones,
        loading,
        error,
        reload,
        createHabitacion,
        updateHabitacion,
        deleteHabitacion,
    };
}
